export default __webpack_public_path__ + "static/media/BoyPage1.ab454a1d.txt";